import React, { useState } from 'react';
import { Button } from './button';
import { Input } from './input';
import { Field } from './fieldset';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase'; // Import your Firebase instance
import { useBranding } from '../hooks/useBranding';

const ForgotPassword = () => {
  const branding = useBranding();
  // One color is enough — fill the missing side from the other.
  const gradFrom = branding.colorPrimario || branding.colorSecundario;
  const gradTo = branding.colorSecundario || branding.colorPrimario;
  const hasCustomColors = Boolean(gradFrom);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError('Por favor ingresa tu correo electrónico.');
      return;
    }

    setLoading(true);
    setMessage('');
    setError('');

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Si el correo existe, se ha enviado un enlace de recuperación.');
    } catch (err) {
      console.error('Password reset error:', err.code, err.message);
      if (err.code === 'auth/user-not-found') {
        // Por seguridad, no revelamos si el email existe o no
        setMessage('Si el correo existe, se ha enviado un enlace de recuperación.');
      } else if (err.code === 'auth/too-many-requests') {
        setError('Demasiados intentos. Por favor espera unos minutos.');
      } else if (err.code === 'auth/invalid-email') {
        setError('El correo electrónico no es válido.');
      } else {
        setError('Error al enviar el correo. Por favor intenta más tarde.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`flex min-h-screen items-center justify-center relative overflow-hidden ${hasCustomColors ? '' : 'bg-gradient-to-br from-azul-surelia to-azul-surelia/80'}`}
      style={hasCustomColors ? { background: `linear-gradient(to bottom right, ${gradFrom}, ${gradTo})` } : {}}
    >
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className={`absolute top-1/4 left-1/4 w-64 h-64 rounded-full blur-3xl ${branding.isWhiteLabel ? 'bg-white' : 'bg-verde-lima'}`}></div>
        <div className={`absolute bottom-1/4 right-1/4 w-48 h-48 rounded-full blur-3xl ${branding.isWhiteLabel ? 'bg-sky-200' : 'bg-cian-digital'}`}></div>
      </div>

      {/* Logo outside the card */}
      <div className="relative z-10 w-full max-w-md">
        <div className="flex items-center justify-center mb-8">
          <img
            src={branding.logoUrl}
            alt={branding.nombreComercial}
            className="w-auto h-20"
          />
        </div>

        <div className="p-8 bg-white/95 backdrop-blur-sm rounded-xl shadow-2xl border border-azul-surelia/20">

          <div className="text-center mb-8">
            <h3 className="text-xl font-semibold text-azul-surelia">Recuperar Contraseña</h3>
          </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Field>
            <label htmlFor="email" className="text-sm font-medium text-azul-surelia">
              Correo electrónico
            </label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="usuario@ejemplo.com"
              required
            />
          </Field>
          <div className="pt-2">
            <Button type="submit" color="surelia" className="w-full" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar Enlace'}
            </Button>
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          {message && <p className="text-sm text-green-600">{message}</p>}
        </form>

        <div className="mt-4 text-center">
          <a href="/login" className="text-sm text-azul-surelia/70 hover:text-azul-surelia hover:underline font-medium">
            Regresar al Inicio de Sesión
          </a>
        </div>
        </div>

        {branding.isWhiteLabel && (
          <div className="flex items-center justify-center mt-8">
            <img src='/logo-blanco-verde.png' alt="Surelia" className="w-auto h-12" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
